<template>
  <div class="flex">
    <!-- Result stripe -->
    <div class="w-[2px] h-[120px] xl:h-[72px] bg-gray-800" />

    <div class="flex w-full gap-4 bg-gray-900">
      <div class="flex w-full items-center ml-4 gap-4">
        <!-- Left: Map thumbnail + info -->
        <div class="grid grid-cols-3 xl:flex gap-x-6 gap-y-3 xl:gap-6 flex-1">
          <div class="flex flex-2 gap-3">
            <div class="flex relative">
              <div class="min-w-12 min-h-12 h-12 w-12 rounded-md bg-gray-800 animate-pulse" />
              <div class="w-8 h-8 rounded-md absolute top-0 left-0 translate-x-1/4 translate-y-1/4 bg-gray-700 animate-pulse" />
            </div>

            <div class="flex flex-col gap-1 justify-center">
              <div class="h-4 w-12 bg-gray-800 rounded animate-pulse" />
              <div class="flex gap-1 items-center">
                <div class="w-4 h-4 bg-gray-700 rounded animate-pulse" />
                <div class="h-3 w-20 bg-gray-800 rounded animate-pulse" />
              </div>
            </div>
          </div>

          <!-- Rank -->
          <div class="flex-1 flex-col flex gap-1 justify-center">
            <div class="h-3 w-10 bg-gray-800 rounded animate-pulse" />
            <div class="h-4 w-16 bg-gray-800 rounded animate-pulse" />
          </div>

          <!-- Date -->
          <div class="flex-1 flex-col flex gap-1 justify-center">
            <div class="h-3 w-10 bg-gray-800 rounded animate-pulse" />
            <div class="h-4 w-24 bg-gray-800 rounded animate-pulse" />
          </div>

          <!-- K/D/A -->
          <div class="flex-1 flex-col flex gap-1 justify-center">
            <div class="h-3 w-16 bg-gray-800 rounded animate-pulse" />
            <div class="h-4 w-16 bg-gray-800 rounded animate-pulse" />
          </div>

          <!-- HS Kill % -->
          <div class="flex-1 flex-col flex gap-1 justify-center">
            <div class="h-3 w-16 bg-gray-800 rounded animate-pulse" />
            <div class="h-4 w-10 bg-gray-800 rounded animate-pulse" />
          </div>

          <!-- KPR -->
          <div class="flex-1 flex-col flex gap-1 justify-center">
            <div class="h-3 w-10 bg-gray-800 rounded animate-pulse" />
            <div class="h-4 w-10 bg-gray-800 rounded animate-pulse" />
          </div>
        </div>

        <!-- Right: Action button area -->
        <div class="flex flex-col gap-1 justify-start items-start pr-8 ml-8">
          <div class="h-8 w-8 bg-gray-800 rounded-md animate-pulse" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Pure skeleton; no script needed
</script>
